import {useEffect} from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import {Link, useNavigate} from 'react-router-dom';
import { rutaDeVuelta } from '../../../../funciones/rutaDeVuelta';

const DatosCorrectos = ({ envioActivado, redirect = true }) => {
  // console.log(envioActivado);
  const MySwal = withReactContent(Swal);
  useEffect(() => {
    if (envioActivado) {
      showAlert();
    }
  }, [envioActivado]);

  const showAlert = () => {
    let timerInterval;

    MySwal.fire({
        title: "Espere mientras se envian sus datos!",
        timer: 2500,
        timerProgressBar: true,
        
        didOpen: () => {
          Swal.showLoading();
         
          
        },
        willClose: () => {
          clearInterval(timerInterval);
          if (redirect) {
            <Link to={window.history.back()} />
          }
        }
      }).then((result) => {
        
        if (result.dismiss === Swal.DismissReason.timer) {
          const Toast = Swal.mixin({
            toast: true,
            position: 'center',
            showConfirmButton: false,
            timer: 2500,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer);
              toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
          });
          Toast.fire({
            icon: 'success',
            title: 'Cambios realizados exitosamente'
          });
      
        }
      
    });

  };
 
  return null;
};

const DatosCorrectosPerfil = ({ envioActivado }) => {
  const MySwal = withReactContent(Swal);
  
  useEffect(() => {
    if (envioActivado) {
      showAlert();
    } else {
      MySwal.close();
    }
  }, [envioActivado]);

  const showAlert = () => {
    let timerInterval;

    MySwal.fire({
        title: "Espere mientras se envian sus datos!",
        timer: 2000,
        timerProgressBar: true,
        
        didOpen: () => {
            Swal.showLoading();
            },
            willClose: () => {
            clearInterval(timerInterval);
            }
          }).then((result) => {
            if (envioActivado && result.dismiss === Swal.DismissReason.timer) {
              window.location.href = '/panel-inicio';
            }
        if (result.dismiss === Swal.DismissReason.timer) {
          const Toast = Swal.mixin({
            toast: true,
            position: 'center',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer);
              toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
          });
          Toast.fire({
            icon: 'success',
            title: 'Cambios realizados exitosamente'
          });
        }
    });
  };
 
  return null;
};

const DatosCorrectosEmpresa = ({ envioActivado, redirect = true }) => {
  // console.log(envioActivado);
  const navigate = useNavigate()
  const MySwal = withReactContent(Swal);
  useEffect(() => {
    if (envioActivado) {
      showAlert();
    }
  }, [envioActivado]);

  const showAlert = () => {
    let timerInterval;

    MySwal.fire({
        title: "Espere mientras se envian sus datos!",
        timer: 2000,
        timerProgressBar: true,
        
        didOpen: () => {
          Swal.showLoading();
         
          
        },
        willClose: () => {
          clearInterval(timerInterval);
          if (redirect) {
            navigate('/gestionpersonas/empresas')
          }
        }
      }).then((result) => {
        
        if (result.dismiss === Swal.DismissReason.timer) {
          const Toast = Swal.mixin({
            toast: true,
            position: 'center',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer);
              toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
          });
          Toast.fire({
            icon: 'success',
            title: 'Empresa agregada exitosamente'
          });
      
        }
      
    });

  };
 
  return null;
};

const DatosCorrectosDepartamento = ({ envioActivado, redirect = true }) => {
  // console.log(envioActivado);
  const navigate = useNavigate()
  const MySwal = withReactContent(Swal);
  useEffect(() => {
    if (envioActivado) {
      showAlert();
    }
  }, [envioActivado]);

  const showAlert = () => {
    let timerInterval;

    MySwal.fire({
        title: "Espere mientras se envian sus datos!",
        timer: 2000,
        timerProgressBar: true,
        
        didOpen: () => {
          Swal.showLoading();
         
          
        },
        willClose: () => {
          clearInterval(timerInterval);
          if (redirect) {
            navigate('/gestionpersonas/departamentos')
          }
        }
      }).then((result) => {
        
        if (result.dismiss === Swal.DismissReason.timer) {
          const Toast = Swal.mixin({
            toast: true,
            position: 'center',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer);
              toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
          });
          Toast.fire({
            icon: 'success',
            title: 'Departamento agregado exitosamente'
          });
      
        }
      
    });

  };
 
  return null;
};

const DatosCorrectosOficina = ({ envioActivado, redirect = true }) => {
  // console.log(envioActivado);
  const navigate = useNavigate()
  const MySwal = withReactContent(Swal);
  useEffect(() => {
    if (envioActivado) {
      showAlert();
    }
  }, [envioActivado]);

  const showAlert = () => {
    let timerInterval;

    MySwal.fire({
        title: "Espere mientras se envian sus datos!",
        timer: 2000,
        timerProgressBar: true,
        
        didOpen: () => {
          Swal.showLoading();
         
          
        },
        willClose: () => {
          clearInterval(timerInterval);
          if (redirect) {
            navigate('/gestionpersonas/oficinas')
          }
        }
      }).then((result) => {
        
        if (result.dismiss === Swal.DismissReason.timer) {
          const Toast = Swal.mixin({
            toast: true,
            position: 'center',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer);
              toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
          });
          Toast.fire({
            icon: 'success',
            title: 'Oficina agregada exitosamente'
          });
      
        }
      
    });

  };
 
  return null;
};


/* `volverA`: la ruta del proceso de alta o de baja del que se vino a corregir la ficha. Si llega y
 * es válida, «Guardar y salir» vuelve ALLÍ en vez de al listado de personas. Se valida AQUÍ también,
 * y no sólo en quien la pasa: esta salida usa `window.location.href`, que va a donde le digan, así
 * que es el sitio donde un `?volver=` fabricado haría daño (redirect abierto, ver `rutaDeVuelta`). */
const DatosCorrectosPersona = ({ envioActivado, queryParams = '', redirect = true, volverA = null, volverPorHistorial = false }) => {
  // console.log(envioActivado);
  const MySwal = withReactContent(Swal);
  useEffect(() => {
    if (envioActivado) {
      showAlert();
    }
  }, [envioActivado]);

  const showAlert = () => {
    let timerInterval;

    MySwal.fire({
        title: "Espere mientras se envian sus datos!",
        timer: 2000,
        timerProgressBar: true,
        
        didOpen: () => {
          Swal.showLoading();
         
          
        },
        willClose: () => {
          clearInterval(timerInterval);
          if (redirect) {
            const vuelta = rutaDeVuelta(volverA);
            // Con vuelta, igual que las otras salidas de la ficha: retroceder si se llegó navegando
            // desde el proceso, o SUSTITUIR esta entrada si no. Así el «Volver» del proceso sigue
            // llevando al listado y no a esta ficha.
            if (vuelta && volverPorHistorial) window.history.back();
            else if (vuelta) window.location.replace(vuelta);
            else window.location.href = `/gestionpersonas/personas${queryParams}`;
          }
        }
      }).then((result) => {
        
        if (result.dismiss === Swal.DismissReason.timer) {
          const Toast = Swal.mixin({
            toast: true,
            position: 'center',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer);
              toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
          });
          Toast.fire({
            icon: 'success',
            title: 'Persona agregada exitosamente'
          });
      
        }
      
    });

  };
 
  return null;
};

const ServerNoCreoCurso = ({ envioActivado }) => {
  useEffect(() => {
    if (envioActivado) {
      showAlert();
    }
  }, [envioActivado]);

  const showAlert = () => {
    Swal.fire({
        icon: "error",
        title: "No se pudo crear el curso",
        text: "Este curso ya existe",
        
      
    }).then((result) => {
      if (result.isConfirmed) {
        envioActivado=false
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        <Link to={window.history.back()} />
      }
    });
  };

  return null;
};

const ServerNoCreoDepartamento = ({ envioActivado, editar=false }) => {
  useEffect(() => {
    if (envioActivado) {
      showAlert();
    }
  }, [envioActivado]);

  const showAlert = () => {
    Swal.fire({
        icon: "error",
        title: `No se pudo ${editar ? 'editar' : 'agregar'} el departamento`,
        text: "Este departamento ya existe",
        
      
    }).then((result) => {
      if (result.isConfirmed) {
        envioActivado=false
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        <Link to={window.history.back()} />
      }
    });
  };

  return null;
};

const ServerNoCreoOficina = ({ envioActivado, editar=false }) => {
  useEffect(() => {
    if (envioActivado) {
      showAlert();
    }
  }, [envioActivado]);

  const showAlert = () => {
    Swal.fire({
        icon: "error",
        title: `No se ha podido modificar la oficina`,
        text: `Error`,
        
      
    }).then((result) => {
      if (result.isConfirmed) {
        envioActivado=false
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        <Link to={window.history.back()} />
      }
    });
  };

  return null;
};

const ServerNoCreoEmpresa = ({ envioActivado, editar=false }) => {
  useEffect(() => {
    if (envioActivado) {
      showAlert();
    }
  }, [envioActivado]);

  const showAlert = () => {
    Swal.fire({
        icon: "error",
        title: `No se pudo ${editar ? 'editar' : 'agregar'} la empresa`,
        text: "Esta empresa ya existe",
        
      
    }).then((result) => {
      if (result.isConfirmed) {
        envioActivado=false
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        <Link to={window.history.back()} />
      }
    });
  };

  return null;
};

const ServerNoCreoPersona = ({ envioActivado, editar=false }) => {
  useEffect(() => {
    if (envioActivado) {
      showAlert();
    }
  }, [envioActivado]);

  const showAlert = () => {
    Swal.fire({
        icon: "error",
        title: `No se pudo ${editar ? 'editar' : 'agregar'} la persona`,
        text: `Este ${editar ? 'email' : 'dni o email'} ya existe`,
        
      
    }).then((result) => {
      if (result.isConfirmed) {
        envioActivado=false
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        <Link to={window.history.back()} />
      }
    });
  };

  return null;
};

const ServerUrlAFExistente = ({ envioActivado }) => {
  useEffect(() => {
    if (envioActivado) {
      showAlert();
    }
  }, [envioActivado]);

  const showAlert = () => {
    Swal.fire({
        icon: "error",
        title: "Url y AF repetida",
        text: "Este curso ya existe",
        
      
    }).then((result) => {
      if (result.isConfirmed) {
        envioActivado=false
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        <Link to={window.history.back()} />
      }
    });
  };

  return null;
};

const CategoriaExistente = ({ envioActivado }) => {
  useEffect(() => {
    if (envioActivado) {
      showAlert();
    }
  }, [envioActivado]);

  const showAlert = () => {
    Swal.fire({
        icon: "error",
        title: "Categoria existe",
        text: "Está categoría ya existe",
        
      
    }).then((result) => {
      if (result.isConfirmed) {
        envioActivado=false
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        <Link to={window.history.back()} />
      }
    });
  };

  return null;
};

const PublicacionExistente = ({ envioActivado }) => {
  useEffect(() => {
    if (envioActivado) {
      showAlert();
    }
  }, [envioActivado]);

  const showAlert = () => {
    Swal.fire({
        icon: "error",
        title: "Publicacion existe",
        text: "Está publicación ya existe",
        
      
    }).then((result) => {
      if (result.isConfirmed) {
        envioActivado=false
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        <Link to={window.history.back()} />
      }
    });
  };

  return null;
};

const CategoriaPublicacionExistente = ({ envioActivado }) => {
  useEffect(() => {
    if (envioActivado) {
      showAlert();
    }
  }, [envioActivado]);

  const showAlert = () => {
    Swal.fire({
        icon: "error",
        title: "Categoría existe",
        text: "Está categoría ya existe",
        
      
    }).then((result) => {
      if (result.isConfirmed) {
        envioActivado=false
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        <Link to={window.history.back()} />
      }
    });
  };

  return null;
};


const DatosIncorrectos = ({ envioActivado, passwordIncorrecto = false, duplicado = false }) => {
    useEffect(() => {
      if (envioActivado==false && passwordIncorrecto==false && duplicado==false) {
        showAlert();
      }
    }, [envioActivado]);
  
    const showAlert = () => {
      Swal.fire({
        icon: "warning",
          title: "Error de Petición",
          text: "Ha habido un error en la petición. Intentelo más tarde",
          
        
      }).then((result) => {
        if (result.isConfirmed) {
          envioActivado=false
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          <Link to={window.history.back()} />
        }
      });
    };
  
    return null;
  };

  const PasswordIncorrecto = ({ envioActivado }) => {
    useEffect(() => {
      if (envioActivado==true) {
        showAlert();
      }
    }, [envioActivado]);
  
    const showAlert = () => {
      Swal.fire({
        icon: "warning",
          title: "Contraseña no válida",
          text: "La contraseña actual no es válida",
          
        
      }).then((result) => {
        if (result.isConfirmed) {
          envioActivado=false
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          <Link to={window.history.back()} />
        }
      });
    };
  
    return null;
  };


  
  const ConfirmacionEliminar = () => {
    const showAlert = (mensaje,nombre) => {
        return Swal.fire({
            title: `¿Seguro que quieres ${mensaje} est@s ${nombre}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí',
            cancelButtonText: 'No',
        }).then((result) => {
            return result.isConfirmed;
        });
    };

    return { showAlert };
};

const ConfirmacionEliminarEmpresa = () => {
    const showAlert = (mensaje,nombre) => {
        return Swal.fire({
            title: `¿Seguro que quieres eliminar la empresa?`,
            text: `Esta accion eliminara las personas y departamentos asociadas a él.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            return result.isConfirmed;
        });
    };

    return { showAlert };
};

const ConfirmacionEliminarOficina = () => {
    const showAlert = (mensaje,nombre) => {
        return Swal.fire({
            title: `¿Seguro que quieres eliminar la oficina?`,
            text: `Esta accion eliminara las oficinas asociadas a él.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            return result.isConfirmed;
        });
    };

    return { showAlert };
};

const ConfirmacionEliminarDepartamento = () => {
    const showAlert = (mensaje,nombre) => {
        return Swal.fire({
            title: `¿Seguro que quieres eliminar el departamento?`,
            text: `Esta accion eliminara las dependencias de los departamentos y los cargos que dependan de él.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            return result.isConfirmed;
        });
    };

    return { showAlert };
};

const Error = (errorMessage = "¡Ha ocurrido un error en la solicitud!") => {
    return Swal.fire({
        icon: "error",
        title: "ERROR",
        text: errorMessage,
    });
};

export {DatosCorrectos, Error, ConfirmacionEliminarEmpresa, ConfirmacionEliminarOficina, PublicacionExistente, ServerNoCreoOficina, DatosCorrectosOficina, ConfirmacionEliminarDepartamento, ServerNoCreoCurso, DatosIncorrectos, DatosCorrectosPerfil, PasswordIncorrecto, ConfirmacionEliminar,ServerUrlAFExistente, CategoriaExistente, DatosCorrectosPersona, ServerNoCreoPersona, ServerNoCreoDepartamento,  DatosCorrectosEmpresa, ServerNoCreoEmpresa, DatosCorrectosDepartamento, CategoriaPublicacionExistente};
